import * as React from 'react';
import {connect} from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import {getPropertyManagersAction,addVendorCategoryAction} from '../../actions';
import Select from "react-select";
import {ErrorMessage, Field, Form, Formik} from "formik";
import * as Yup from 'yup';
import {vendorCategoryValidationSchema} from "../../utils/form/getValidationSchema";

export interface Props extends RouteComponentProps<any> {
    match : any,
    getPropertyManagersAction: any,
    properties: any;
    addVendorCategoryAction: any,
}

export interface State {
    general_aggregate: any,
    any_auto: any,
    bodily_injury_per_accident: any,
    aggregate: any,
    property: any,
    each_accident: any,
    claims_made_umbrella: any,
    non_owned_autos_only: any,
    hired_autos_only: any,
    owned_autos_only: any,
    each_occourrence: any,
    disease_ea_employee: any,
    disease_policy_limit: any,
    combined_single_limit: any,
    claims_made: any,
    bodily_injury_per_person: any,
    name: any,
    certificate_holders: any,
    scheduled_autos: any,
    property_damage_per_accident: any,
    personal_adv_injury: any,
    damage_to_rented_premises: any,
    per_statute: any,
    occur: any,
    occur_umbrella: any,
    products_comp: any,
    other: any,
    each_occurence: any,
    med_exp: any,
    vendorCategoryNameEdit: any,
}

const formInitialValue = {
    each_occourrence:               '',
    damage_to_rented_premises:      '',
    med_exp:                        '',
    personal_adv_injury:            '',
    general_aggregate:              '',
    products_comp:                  '',
    combined_single_limit:          '',
    bodily_injury_per_person:       '',
    bodily_injury_per_accident:     '',
    property_damage_per_accident:   '',
    each_occurence:                 '',
    aggregate:                      '',
    each_accident:                  '',
    disease_ea_employee:            '',
    disease_policy_limit:           '',
};

class CategoryView extends React.Component<Props,State>  {
    state = {
        vendorCategoryNameEdit: false,
        general_aggregate: '',
        any_auto: false,
        bodily_injury_per_accident: '',
        aggregate: '',
        property: '',
        each_accident: '',
        claims_made_umbrella: false,
        non_owned_autos_only: false,
        hired_autos_only: false,
        owned_autos_only: false,
        each_occourrence: '',
        disease_ea_employee: '',
        disease_policy_limit: '',
        combined_single_limit: '',
        claims_made: false,
        bodily_injury_per_person: '',
        name: "",
        certificate_holders: [['']],
        scheduled_autos: false,
        property_damage_per_accident: '',
        personal_adv_injury: '',
        damage_to_rented_premises: '',
        per_statute: false,
        occur: false,
        occur_umbrella: false,
        products_comp: '',
        other: false,
        each_occurence: '',
        med_exp: ''
    };

    componentDidMount () {
        this.setState({name:this.props.match.params.name});
        const getProperties = this.props.getPropertyManagersAction();
        getProperties.then((res)=> {
            const property = {
                label:res.data.results[0].property_name,
                value:res.data.results[0].property
            };
            this.setState({name:this.props.match.params.name,property});
        })
    }
    handelSumbmit = () => {
        const {certificate_holders,name,claims_made, each_occourrence,damage_to_rented_premises,
            med_exp,personal_adv_injury,general_aggregate,products_comp,occur,combined_single_limit,bodily_injury_per_person,
            bodily_injury_per_accident,property_damage_per_accident,any_auto,owned_autos_only,hired_autos_only,scheduled_autos,
            non_owned_autos_only,each_occurence,aggregate,occur_umbrella,claims_made_umbrella,each_accident,disease_ea_employee,
            disease_policy_limit,per_statute,other,property
        } = this.state;

        const data = {
            certificate_holders,
            name,
            claims_made,
            each_occourrence: +each_occourrence,
            damage_to_rented_premises: +damage_to_rented_premises,
            med_exp: +med_exp,
            personal_adv_injury: +personal_adv_injury,
            general_aggregate: +general_aggregate,
            products_comp: +products_comp,
            occur,
            combined_single_limit: +combined_single_limit,
            bodily_injury_per_person: +bodily_injury_per_person,
            bodily_injury_per_accident: +bodily_injury_per_accident,
            property_damage_per_accident: +property_damage_per_accident,
            any_auto,
            owned_autos_only,
            hired_autos_only,
            scheduled_autos,
            non_owned_autos_only,
            each_occurence: +each_occurence,
            aggregate: +aggregate,
            occur_umbrella,
            claims_made_umbrella,
            each_accident: +each_accident,
            disease_ea_employee: +disease_ea_employee,
            disease_policy_limit: +disease_policy_limit,
            per_statute,
            other,
            // @ts-ignore
            property: property.value
        };

        this.props.addVendorCategoryAction(data).then(() => {
            this.props.history.push('/settings/vendor-coi');
        })
    };

    addNewCerHolder = () => {
       const certificate_holders = this.state.certificate_holders;
       certificate_holders.push(['']);
       this.setState({certificate_holders});
    };

    onCHInpChange = (e,i) => {
        const certificate_holders = this.state.certificate_holders;
        certificate_holders[i][0] = e.target.value;
        console.log(certificate_holders);
        this.setState({certificate_holders});
    };

    onCheckboxChange = (e) => {
        // @ts-ignore
        this.setState({[e.target.name]: e.target.checked})
    };
    oninputChange = (e) => {
        // @ts-ignore
        this.setState({[e.target.name]: e.target.value})
    };

    onSelectChange = (name:string, value) => {
        // @ts-ignore
        this.setState({[name]: value})
    }

    onSubmitModal = async (values) => {
        await this.setState(values);
        this.handelSumbmit();
    }

    render(){
        const {certificate_holders,vendorCategoryNameEdit,name,claims_made, occur, any_auto,owned_autos_only,hired_autos_only,scheduled_autos,
            non_owned_autos_only, occur_umbrella,claims_made_umbrella,
            per_statute,other,property
        } = this.state;
        const {properties} = this.props;
        const pros = properties && properties.map((pro) => {
            return {value: pro.property_name, label: pro.property_name}
        }) ||  [];
        return (
            <div className="page-content vendor-category">
                <h1 className="page-title">settings</h1>
                <span className="page-icon">
                <i className="icon-settings"/>
            </span>
                <div className="main-content mt-6">
                    <Formik
                        {...[this.props]}
                        enableReinitialize
                        initialValues={formInitialValue}
                        // validate={validate(validationSchema)}
                        validationSchema={Yup.object().shape(vendorCategoryValidationSchema)}
                        onSubmit={ this.onSubmitModal }
                    >
                        {({errors, touched, ...rest}) => {
                            return (
                                <Form>
                    <h2 className="page-subtitle">vendor COI</h2>
                    <div className="category">
                        <div className="flex align-center mb-7">
                            <p className="category-name">Vendor Category: {!vendorCategoryNameEdit && <span className="ml-4 text-capitalize">{name}</span> ||<span  className="text-field primary">
                              <input type="text" value={name} onChange={(e) => this.setState({name: e.target.value})} /> </span>}</p>
                            <a className="color-black underline" onClick={() => this.setState({vendorCategoryNameEdit:!vendorCategoryNameEdit})} >{!vendorCategoryNameEdit && 'edit' || 'save'}</a>
                        </div>
                        <p className="holders">Required Certificate Holders</p>
                        {certificate_holders.map((ch,index)=> {

                            return(
                                <div key={index} className="text-field primary">
                                    <input value={certificate_holders[index]} type="text" onChange={(e)=> this.onCHInpChange(e,index)} placeholder="add certificate holder"/>
                                </div>
                            )
                        })}

                        <a onClick={this.addNewCerHolder} className="color-black inline-block mb-7 pt-3">+ add another required certificate holder</a>
                        <ul className="options">
                            <li>
                                <label className="checkbox axis">
                                    <input type="checkbox" className="checkbox-control" name="searchable" />
                                    <span className="check-icon">{''}</span>
                                    <span className="checkbox-label">+ MUST be named in Certificate Holder section</span>
                                </label>
                            </li>
                            <li>
                                <label className="checkbox axis">
                                    <input type="checkbox" className="checkbox-control" name="searchable" />
                                    <span className="check-icon">{''}</span>
                                    <span className="checkbox-label">+ can be mentioned in the Description of Operations</span>
                                </label>
                            </li>
                        </ul>
                    </div>
                    <div className="category">
                        <p className="holders">Minimum limits</p>
                        <p className="mb-9">Select as many or as little necessary requirements below</p>
                        <p className="category-name">Commercial General Liability</p>
                        <p className="info-text">Select the required boxes and relevant information </p>
                        <ul className="category-list">
                            <li>
                                <span className="label">each occurrence</span>
                                <div className={"text-field primary icon no-margin "+ ((errors.each_occourrence && touched.each_occourrence) ? 'invalid' : '' )}>
                                    {/*<input type="text" value={each_occourrence} name={'each_occourrence'} onChange={this.oninputChange}/>*/}
                                    <Field name="each_occourrence" type="input" />
                                    <ErrorMessage name="each_occourrence"/>
                                    <span className="input-icon">$</span>
                                </div>
                            </li>
                            <li>
                                <span className="label">damage to rented premises</span>
                                <div className={"text-field primary icon no-margin "+ ((errors.damage_to_rented_premises && touched.damage_to_rented_premises) ? 'invalid' : '' )}>
                                    {/*<input type="text" value={damage_to_rented_premises} name={'damage_to_rented_premises'} onChange={this.oninputChange}/>*/}
                                    <Field name="damage_to_rented_premises" type="input" />
                                    <ErrorMessage name="damage_to_rented_premises"/>
                                    <span className="input-icon">$</span>
                                    {/*<p className="error-text">* This field is required.</p>*/}
                                </div>
                            </li>
                            <li>
                                <span className="label">Med Exp</span>
                                <div className={"text-field primary icon no-margin "+ ((errors.med_exp && touched.med_exp) ? 'invalid' : '' )}>
                                    {/*<input type="text" value={med_exp} name={'med_exp'} onChange={this.oninputChange}/>*/}
                                    <Field name="med_exp" type="input" />
                                    <ErrorMessage name="med_exp"/>
                                    <span className="input-icon">$</span>
                                </div>
                            </li>
                            <li>
                                <span className="label">Personal & Adv Injury</span>
                                <div className={"text-field primary icon no-margin "+ ((errors.personal_adv_injury && touched.personal_adv_injury) ? 'invalid' : '' )}>
                                    {/*<input type="text" value={personal_adv_injury} name={'personal_adv_injury'} onChange={this.oninputChange}/>*/}
                                    <Field name="personal_adv_injury" type="input" />
                                    <ErrorMessage name="personal_adv_injury"/>
                                    <span className="input-icon">$</span>
                                </div>
                            </li>
                            <li>
                                <span className="label">General Aggregate</span>
                                <div className={"text-field primary icon no-margin "+ ((errors.general_aggregate && touched.general_aggregate) ? 'invalid' : '' )}>
                                    {/*<input type="text" value={general_aggregate} name={'general_aggregate'} onChange={this.oninputChange}/>*/}
                                    <Field name="general_aggregate" type="input" />
                                    <ErrorMessage name="general_aggregate"/>
                                    <span className="input-icon">$</span>
                                </div>
                            </li>
                            <li>
                                <span className="label">Products - Comp/OP AGG</span>
                                <div className={"text-field primary icon no-margin "+ ((errors.products_comp && touched.products_comp) ? 'invalid' : '' )}>
                                    {/*<input type="text"  value={products_comp} name={'products_comp'} onChange={this.oninputChange}/>*/}
                                    <Field name="products_comp" type="input" />
                                    <ErrorMessage name="products_comp"/>
                                    <span className="input-icon">$</span>
                                </div>
                            </li>
                        </ul>
                        <ul className="category-options">
                            <li>
                                <label className="checkbox axis">
                                    <input type="checkbox" className="checkbox-control" name="claims_made" onChange={(e) => this.onCheckboxChange(e)} checked={claims_made}/>
                                    <span className="check-icon">{''}</span>
                                    <span className="checkbox-label text-uppercase">claims-made</span>
                                </label>
                            </li>
                            <li>
                                <label className="checkbox axis">
                                    <input type="checkbox" className="checkbox-control" name="occur" onChange={(e) => this.onCheckboxChange(e)} checked={occur}/>
                                    <span className="check-icon">{''}</span>
                                    <span className="checkbox-label text-uppercase">occur</span>
                                </label>
                            </li>
                        </ul>
                    </div>
                    <div className="category">
                        <p className="category-name">Automobile Liability</p>
                        <p className="mb-9">Select the required boxes and relevant information </p>
                        <ul className="category-list">
                            <li>
                                <span className="label">combined single limit</span>
                                <div className={"text-field primary icon no-margin "+ ((errors.combined_single_limit && touched.combined_single_limit) ? 'invalid' : '' )}>
                                    {/*<input type="text" value={combined_single_limit} name={'combined_single_limit'} onChange={this.oninputChange}/>*/}
                                    <Field name="combined_single_limit" type="input" />
                                    <ErrorMessage name="combined_single_limit"/>
                                    <span className="input-icon">$</span>
                                </div>
                            </li>
                            <li>
                                <span className="label">Bodily Injury (per person)</span>
                                <div className={"text-field primary icon no-margin "+ ((errors.bodily_injury_per_person && touched.bodily_injury_per_person) ? 'invalid' : '' )}>
                                    {/*<input type="text" value={bodily_injury_per_person} name={'bodily_injury_per_person'} onChange={this.oninputChange}/>*/}
                                    <Field name="bodily_injury_per_person" type="input" />
                                    <ErrorMessage name="bodily_injury_per_person"/>
                                    <span className="input-icon">$</span>
                                </div>
                            </li>
                            <li>
                                <span className="label">Bodily Injury (per accident)</span>
                                <div className={"text-field primary icon no-margin "+ ((errors.bodily_injury_per_accident && touched.bodily_injury_per_accident) ? 'invalid' : '' )}>
                                    {/*<input type="text" value={bodily_injury_per_accident} name={'bodily_injury_per_accident'} onChange={this.oninputChange}/>*/}
                                    <Field name="bodily_injury_per_accident" type="input" />
                                    <ErrorMessage name="bodily_injury_per_accident"/>
                                    <span className="input-icon">$</span>
                                </div>
                            </li>
                            <li>
                                <span className="label">Property damage (per accident)</span>
                                <div className={"text-field primary icon no-margin "+ ((errors.property_damage_per_accident && touched.property_damage_per_accident) ? 'invalid' : '' )}>
                                    {/*<input type="text" value={property_damage_per_accident} name={'property_damage_per_accident'} onChange={this.oninputChange}/>*/}
                                    <Field name="property_damage_per_accident" type="input" />
                                    <ErrorMessage name="property_damage_per_accident"/>
                                    <span className="input-icon">$</span>
                                </div>
                            </li>
                        </ul>
                        <ul className="category-options">
                            <li>
                                <label className="checkbox axis">
                                    <input type="checkbox" className="checkbox-control" name="any_auto" checked={any_auto} onChange={this.onCheckboxChange}/>
                                    <span className="check-icon">{''}</span>
                                    <span className="checkbox-label text-uppercase">ANY AUTO</span>
                                </label>
                            </li>
                            <li>
                                <label className="checkbox axis">
                                    <input type="checkbox" className="checkbox-control" name="owned_autos_only" checked={owned_autos_only} onChange={this.onCheckboxChange} />
                                    <span className="check-icon">{''}</span>
                                    <span className="checkbox-label text-uppercase">OWNED AUTOS ONLY</span>
                                </label>
                            </li>
                            <li>
                                <label className="checkbox axis">
                                    <input type="checkbox" className="checkbox-control" name="hired_autos_only" checked={hired_autos_only} onChange={this.onCheckboxChange}/>
                                    <span className="check-icon">{''}</span>
                                    <span className="checkbox-label text-uppercase">HIRED AUTOS ONLY</span>
                                </label>
                            </li>
                            <li>
                                <label className="checkbox axis">
                                    <input type="checkbox" className="checkbox-control" name="scheduled_autos" checked={scheduled_autos} onChange={this.onCheckboxChange} />
                                    <span className="check-icon">{''}</span>
                                    <span className="checkbox-label text-uppercase">SCHEDULED AUTOS</span>
                                </label>
                            </li>
                            <li>
                                <label className="checkbox axis">
                                    <input type="checkbox" className="checkbox-control" name="non_owned_autos_only" checked={non_owned_autos_only} onChange={this.onCheckboxChange}/>
                                    <span className="check-icon">{''}</span>
                                    <span className="checkbox-label text-uppercase">NON-OWNED AUTOS ONLY</span>
                                </label>
                            </li>
                        </ul>
                    </div>
                    <div className="category">
                        <p className="category-name">Umbrella Liability</p>
                        <p className="info-text">Select the required boxes and relevant information </p>
                        <ul className="category-list ml-10 pl-2">
                            <li>
                                <span className="label">each occurrence</span>
                                <div className={"text-field primary icon no-margin "+ ((errors.each_occurence && touched.each_occurence) ? 'invalid' : '' )}>
                                    {/*<input type="text" value={each_occurence} name={'each_occurence'} onChange={this.oninputChange}/>*/}
                                    <Field name="each_occurence" type="input" />
                                    <ErrorMessage name="each_occurence"/>
                                    <span className="input-icon">$</span>
                                </div>
                            </li>
                            <li>
                                <span className="label">aggregate</span>
                                <div className={"text-field primary icon no-margin "+ ((errors.aggregate && touched.aggregate) ? 'invalid' : '' )}>
                                    {/*<input type="text" value={aggregate} name={'aggregate'} onChange={this.oninputChange}/>*/}
                                    <Field name="aggregate" type="input" />
                                    <ErrorMessage name="aggregate"/>
                                    <span className="input-icon">$</span>
                                </div>
                            </li>
                        </ul>
                        <ul className="category-options">
                            <li>
                                <label className="checkbox axis">
                                    <input type="checkbox" className="checkbox-control" name="claims_made_umbrella"  checked={claims_made_umbrella} onChange={this.onCheckboxChange}/>
                                    <span className="check-icon">{''}</span>
                                    <span className="checkbox-label text-uppercase">claims-made</span>
                                </label>
                            </li>
                            <li>
                                <label className="checkbox axis">
                                    <input type="checkbox" className="checkbox-control" name="occur_umbrella"  checked={occur_umbrella} onChange={this.onCheckboxChange} />
                                    <span className="check-icon">{''}</span>
                                    <span className="checkbox-label text-uppercase">occur</span>
                                </label>
                            </li>
                        </ul>
                    </div>
                    <div className="category">
                        <p className="category-name">Workers Compensation</p>
                        <p className="info-text">Select the required boxes and relevant information </p>
                        <ul className="category-list ml-10">
                            <li>
                                <span className="label">E.L. EACH ACCIDENT</span>
                                <div className={"text-field primary icon no-margin "+ ((errors.each_accident && touched.each_accident) ? 'invalid' : '' )}>
                                    {/*<input type="text" name={'each_accident'} value={each_accident} onChange={this.oninputChange}/>*/}
                                    <Field name="each_accident" type="input" />
                                    <ErrorMessage name="each_accident"/>
                                    <span className="input-icon">$</span>
                                </div>
                            </li>
                            <li>
                                <span className="label">E.L. DISEASE - EA EMPLOYEE</span>
                                <div className={"text-field primary icon no-margin "+ ((errors.disease_ea_employee && touched.disease_ea_employee) ? 'invalid' : '' )}>
                                    {/*<input type="text" name={'disease_ea_employee'} value={disease_ea_employee} onChange={this.oninputChange}/>*/}
                                    <Field name="disease_ea_employee" type="input" />
                                    <ErrorMessage name="disease_ea_employee"/>
                                    <span className="input-icon">$</span>
                                </div>
                            </li>
                            <li>
                                <span className="label">E.L. DISEASE - POLICY LIMIT</span>
                                <div className={"text-field primary icon no-margin "+ ((errors.disease_policy_limit && touched.disease_policy_limit) ? 'invalid' : '' )}>
                                    {/*<input type="text" name={'disease_policy_limit'} value={disease_policy_limit} onChange={this.oninputChange}/>*/}
                                    <Field name="disease_policy_limit" type="input" />
                                    <ErrorMessage name="disease_policy_limit"/>
                                    <span className="input-icon">$</span>
                                </div>
                            </li>
                        </ul>
                        <ul className="category-options">
                            <li>
                                <label className="checkbox axis">
                                    <input type="checkbox" className="checkbox-control" name="per_statute" checked={per_statute} onChange={this.onCheckboxChange}/>
                                    <span className="check-icon">{''}</span>
                                    <span className="checkbox-label text-uppercase">PER STATUTE</span>
                                </label>
                            </li>
                            <li>
                                <label className="checkbox axis">
                                    <input type="checkbox" className="checkbox-control" name="other" checked={other} onChange={this.onCheckboxChange}/>
                                    <span className="check-icon">{''}</span>
                                    <span className="checkbox-label text-uppercase">other</span>
                                </label>
                            </li>
                        </ul>
                    </div>
                        {properties &&
                        <div className="flex justify-end">
                            <div className="select-box">
                                <span className="label">select a property:</span>
                                <Select  value={property} name='selectedProperty'
                                         onChange={(value) => this.onSelectChange('property', value)}
                                         options={pros} />
                            </div>
                        </div>}
                        {/*<button onClick={this.handelSumbmit} type='button'> SAVE </button>*/}
                        <button type='submit'> SAVE </button>
                            {/*<pre>*/}
                            {/*{JSON.stringify(rest, null, 2)}*/}
                            {/*</pre>*/}
                                </Form>
                            )
                        }}
                    </Formik>
                </div>

            </div>

        )
    }

};

const mapStateToProps = state => {
    return{
        properties: state.settings.properties,
    }
};

export default connect(mapStateToProps,{getPropertyManagersAction,addVendorCategoryAction})(CategoryView);


// WEBPACK FOOTER //
// ./src/components/Settings/CategoryView.tsx